<script>
import _ from 'lodash'

export default {
  data() {
    return {
      globalFilterDialogVisible: false,
      globalFilterActive: false,
      globalFilterEnabled: false,
      globalFilterDisabled: false,
      globalFilterConfirmationDialogVisible: false,
      tempGlobalFilter: {
        isActive: true,
        selections: [],
      },
      tempGlobalFilterConfirmation: true,
    }
  },

  computed: {
    getGlobalFilterText() {
      // get counts
      const airlinesCount = this.getAirlinesCount()
      const masterModelsCount = this.getMasterModelsCount()

      if (this.isGlobalFilterActive) {
        if (airlinesCount > 0 && masterModelsCount > 0) {
          return `${airlinesCount} A / ${masterModelsCount} P`
        }

        return 'Global Filter'
      }

      return 'Global Filter Off'
    },

    getGlobalFilterTooltip() {
      let pageName = ''
      const route = this.$route

      if (this.isGlobalFilterActive) {
        switch (route.name) {
          case 'Aircraft Data':
            pageName = 'an Aircraft Data'
            break
          case 'Report Details':
            pageName = 'a Report Details'
            break
          case 'Mx Recs':
            pageName = this.isInternalUser ? 'a Mx & Alert' : 'a Mx Rec'
            break
          case 'User Profile':
            pageName = 'the User Profile'
            break
          case 'Admin':
            pageName = 'the Admin'
            break
          case 'Analytic Management':
            pageName = 'the Analytic Management'
            break
          case 'User Management':
            pageName = 'the User Management'
            break
          case 'Airline Management':
            pageName = 'the Airline Management'
            break
          case 'Document Management':
            pageName = 'the Document Management'
            break
          case 'Feature Flags':
            pageName = 'the Feature Flags'
            break
          case 'Help & About':
            pageName = 'the Help & About'
            break
          case 'Privacy Statement':
            pageName = 'the Privacy Statement'
            break
          case 'Release Notes':
            pageName = 'the Release Notes'
            break
          case 'Terms & Conditions':
            pageName = 'the Terms & Conditions'
            break
          case 'Custom Parameters':
            pageName = 'the Custom Parameters'
            break
          case 'dashboards':
            pageName = 'the dashboards'
            break
          case 'Custom Analytics':
            pageName = 'Custom Analytics'
            break
          default:
            pageName = 'this'
        }

        return `You cannot change the global filter while on ${pageName} page.`
      }

      return 'All data is showing in Ascentia.'
    },

    isGlobalFilterDisabled() {
      const route = this.$route
      return [
        'Admin',
        'Aircraft Data',
        'Airline Management',
        'Analytic Management',
        'Document Management',
        'Feature Flags',
        'Help & About',
        'Mx Recs',
        'Privacy Statement',
        'Release Notes',
        'Report Details',
        'Terms & Conditions',
        'User Management',
        'User Profile',
        'Set Alert',
        'Custom Alert',
        'Custom Alerts',
        'Subscription Center',
        'Subscription Details',
        'Custom Parameters',
        'My Custom Parameter',
        'dashboards',
        'Signatures',
        'Feature Details',
        'Custom Analytics',
        'Custom Analytic',
      ].includes(route.name)
    },

    isGlobalFilterActive() {
      if (this.globalFilter) {
        return this.globalFilter.isActive
      }

      return true
    },

    isGlobalFilterEnabled() {
      // get counts
      const airlinesCount = this.getAirlinesCount()
      const masterModelsCount = this.getMasterModelsCount()

      return airlinesCount > 0 || masterModelsCount > 0
    },

    isGlobalFilterVisisble() {
      // get counts
      const airlinesCount = this.getAirlinesCount()
      const masterModelsCount = this.getMasterModelsCount()

      return airlinesCount > 0 || masterModelsCount > 0
    },
  },

  methods: {
    getAirlinesCount() {
      const selections = this.globalFilter.selections || []
      const groupedAirlines = _.groupBy(selections, 'airlineId')
      return Object.keys(groupedAirlines).length
    },

    getMasterModelsCount() {
      const selections = this.globalFilter.selections || []
      const groupedMasterModels = _.groupBy(selections, 'masterModelId')
      return Object.keys(groupedMasterModels).length
    },

    handleManageGaf() {
      this.globalFilterDialogVisible = true
    },

    handleGlobalFilterDialog(options) {
      // set tempGlobalFilter
      this.tempGlobalFilter = options

      // display confirmation dialog
      if (this.tempGlobalFilterConfirmation) {
        this.globalFilterConfirmationDialogVisible = true
        return
      }

      // automatically apply globalFilter in localStorage and close dialog
      this.applyGlobalFilter()
      this.globalFilterDialogVisible = false
    },

    handleCloseGlobalFilterDialog() {
      this.globalFilterDialogVisible = false
    },

    handleGlobalFilterConfirmationDialog(options) {
      this.applyGlobalFilter()
      this.globalFilterDialogVisible = false
      this.globalFilterConfirmationDialogVisible = false
      this.tempGlobalFilterConfirmation = !options
      this.applyGlobalFilterConfirmation()
    },

    handleCloseConfirmationDialog() {
      this.globalFilterConfirmationDialogVisible = false
    },

    handleCancelConfirmationDialog() {
      this.globalFilterDialogVisible = true
      this.globalFilterConfirmationDialogVisible = false
    },
  },
}
</script>
